import { createContext, createElement, useContext, type ReactNode } from 'react';

export interface AppCapabilities {
    canManageCamera: boolean;
    canSaveObservation: boolean;
    canManageState: boolean;
    canSaveGeodata: boolean;
    canRename: boolean;
    canSwitchCoordinateSystem: boolean;
    canExportToCloud: boolean;
    canOpenProjectPage: boolean;
    showSceneSwitcher: boolean;
    guidedTourEnabled: boolean;
    raysEnabledByDefault: boolean;
    allowCompactUI: boolean;
}

export const NORMAL_CAPABILITIES: AppCapabilities = {
    canManageCamera: true,
    canSaveObservation: true,
    canManageState: true,
    canSaveGeodata: true,
    canRename: true,
    canSwitchCoordinateSystem: true,
    canExportToCloud: true,
    canOpenProjectPage: true,
    showSceneSwitcher: false,
    guidedTourEnabled: false,
    raysEnabledByDefault: false,
    allowCompactUI: true,
};

export const DEMO_CAPABILITIES: AppCapabilities = {
    canManageCamera: false,
    canSaveObservation: false,
    canManageState: false,
    canSaveGeodata: false,
    canRename: false,
    canSwitchCoordinateSystem: false,
    canExportToCloud: false,
    canOpenProjectPage: false,
    showSceneSwitcher: true,
    guidedTourEnabled: true,
    raysEnabledByDefault: true,
    allowCompactUI: true,
};

const CapabilitiesContext = createContext<AppCapabilities>(NORMAL_CAPABILITIES);

export const useCapabilities = () => useContext(CapabilitiesContext);

export function CapabilitiesProvider({ capabilities, children }: { capabilities: AppCapabilities; children: ReactNode }) {
    return createElement(CapabilitiesContext.Provider, { value: capabilities }, children);
}
